import CreateRatePlanButton from "./RatePlanGrid/CreateRatePlanButton";

const HeaderTarifs = ({ openDrawer }) => {
  return (
    <div className="flex items-start justify-between pb-6 border-b border-gray-100">

      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Tarifs
        </h1>
        <p className="text-sm text-gray-400 mt-1">
          Gérez vos plans tarifaires et configurez les prix par période
        </p>
      </div>

      <CreateRatePlanButton openDrawer={openDrawer} />

    </div>
  );
};

export default HeaderTarifs;